import { Typography } from '@mui/material';
import React from 'react';
import { NavLink } from 'react-router-dom';

/**
 * In-app / external nav wrapper. Uses `component="div"` by default so block/flex children
 * (nav rows, icons) do not create invalid `<p>` nesting.
 */
export const Link = ({
	href,
	target,
	children,
	exact,
	component = 'div',
	external = false,
	className,
	sx,
	style,
	// Keep ...props: callers pass onClick, color, mb, etc. onto the outer Typography/Button
	// wrapper (e.g. SpectralData "Retrieve Spectral Data"). Dropping this spread silently breaks
	// click handlers -- see pizza tracker #149 regression (May 2026).
	...props
}) => {
	return (
		<Typography component={component} className={className} sx={sx} style={style} {...props}>
			{external && <a href={href} target={target}>{children}</a>}
			{!external && <NavLink exact={exact} to={href} target={target}>
				{children}
			</NavLink>}
		</Typography>
	);
}

export default Link